import { render, staticRenderFns } from "./XildaStory.vue?vue&type=template&id=4792fc66&"
import script from "./XildaStory.vue?vue&type=script&lang=js&"
export * from "./XildaStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports